const API_ENDPOINTS = {
  STATE_SAVE: "/location/state/save",
  STATE_LIST: "/location/state/list",
  STATE_DELETE: "/location/state/delete",

  CITY_SAVE: "/location/city/save",
  CITY_LIST: "/location/city/list",
  CITY_DELETE: "/location/city/delete",

  PINCODE_SAVE: "/location/pincode/save",
  PINCODE_LIST: "/location/pincode/list",
  PINCODE_DELETE: "/location/pincode/delete",

  CATEGORY_SAVE: "/category/save",
  CATEGORY_LIST: "/category/list",
  CATEGORY_LIST_WITH_CHILDREN: "/category/list-with-children",
  CATEGORY_DELETE: "/category/delete",

 

  OFFERS_SAVE: "/offers/save",
  OFFERS_LIST: "/offers/list",
  OFFERS_DELETE: "/offers/delete",

  PRODUCT_VARIANT_TOGGLE_DEFAULT: "/product/variant/default-toggle",
  PRODUCT_VARIANT_SAVE: "/product/variant/save",
  PRODUCT_VARIANT_LIST: "/product/variant/list",
  PRODUCT_VARIANT_DELETE: "/product/variant/delete",

  MENU_PARENT_SAVE: "/menu/parent/save",
  MENU_PARENT_LIST: "/menu/parent/list",
  MENU_PARENT_DELETE: "/menu/parent/delete",

  BRAND_SAVE: "/brand/save",
  BRAND_LIST: "/brand/list",
  BRAND_DELETE: "/brand/delete",

  COLOR_SAVE: "/color/save",
  COLOR_LIST: "/color/list",
  COLOR_DELETE: "/color/delete",

  SIZE_SAVE: "/size/save",
  SIZE_LIST: "/size/list",
  SIZE_DELETE: "/size/delete",

  MATERIAL_SAVE: "/material/save",
  MATERIAL_LIST: "/material/list",
  MATERIAL_DELETE: "/material/delete",

  PURITY_SAVE: "/purity/save",
  PURITY_LIST: "/purity/list",
  PURITY_DELETE: "/purity/delete",

  LIGHT_TYPE_SAVE: "/light-type/save",
  LIGHT_TYPE_LIST: "/light-type/list",
  LIGHT_TYPE_DELETE: "/light-type/delete",

  PRODUCT_TYPE_SAVE: "/product-type/save",
  PRODUCT_TYPE_LIST: "/product-type/list",
  PRODUCT_TYPE_DELETE: "/product-type/delete",

  BEST_SUITED_FOR_SAVE: "/best-suited-for/save",
  BEST_SUITED_FOR_LIST: "/best-suited-for/list",
  BEST_SUITED_FOR_DELETE: "/best-suited-for/delete",

  COUPON_SAVE: "/coupon/save",
  COUPON_LIST: "/coupon/list",
  COUPON_DELETE: "/coupon/delete",

  USER_SAVE: "/user/save",
  USER_LIST: "/user/list",
  USER_DELETE: "/user/delete",

  // ORDER
  ORDER_LIST: "/order/list",

  COLLECTION_SAVE: "/collection/save",
  COLLECTION_LIST: "/collection/list",
  COLLECTION_DELETE: "/collection/delete",

  HOMEPAGE_SAVE: "/homepage/save",
  HOMEPAGE_LIST: "/homepage/list",
  HOMEPAGE_DELETE: "/homepage/delete",

  SHIPROKCET_PICKUP_LOCATION: "/shiprocket/pickup-locations",
  SHIPROKCET_SHIPMENT_SAVE: "/shiprocket/create-shipment",
  SHIPROKCET_ASSIGN_COURIER: "/shiprocket/assign-courier",

  SHIPROKCET_COURIER_SERVICEBILITY: "/shiprocket/courier-serviceability",

  UPDATE_STATUS: "/shiprocket/update-status",

  SHIPROKCET_AUTHORIZE: "/shiprocket/authorize",
  SHIPROKCET_TRACK_SHIPMENT: "/shiprocket/track-shipment/",



//************************************ */
GET_GROUP_LIST : "manufacturer/group/list",
SAVE_GROUP: "manufacturer/group/save",
DELETE_GROUP: "manufacturer/group/delete",

GET_PRODUCT_TYPE_LIST : "manufacturer/product-type/list",
SAVE_PRODUCT_TYPE: "manufacturer/product-type/save",
DELETE_PRODUCT_TYPE: "manufacturer/product-type/delete",

PRODUCT_SAVE: "/product/save",
PRODUCT_LIST: "/product/list",
PRODUCT_DELETE: "/product/delete",
PRODUCT_DETAILS: "/product/details",
PRODUCT_STATUS_TOGGLE: "/product/status-toggle",


GET_MANUFACTURERS_LIST : "manufacturer/manufacturers/list",
SAVE_MANUFACTURERS: "manufacturer/manufacturers/save",
DELETE_MANUFACTURERS: "manufacturer/manufacturers/delete",


GET_MODEL_RANGE_LIST : "manufacturer/model-range/list",
SAVE_MODEL_RANGE: "manufacturer/model-range/save",
DELETE_MODEL_RANGE: "manufacturer/model-range/delete",

GET_SHEET_SIZE_LIST : "sheet-size/list",
SAVE_SHEET_SIZE: "sheet-size/save",
DELETE_SHEET_SIZE: "sheet-size/delete",



GET_USER_MACHINES_LIST : "sell-machines/list",
DELETE_USER_MACHINES_LIST : "sell-machines/delete",



// SERVICE ENDPOINTS
SERVICE_LIST : "service/list",
SERVICE_DELETE : "service/delete",
SERVICE_SAVE : "service/save",


// TEAM ENDPOINTS
TEAM_MEMBER_LIST : "team-member/list",
TEAM_MEMBER_SAVE : "team-member/save",
TEAM_MEMBER_DELETE : "team-member/delete",


//Contact Queries
CONTACT_QUERY_LIST : "contact/list",
CONTACT_QUERY_DELETE : "contact/delete",


ENQURIES_LIST : "enquiry/list",
ENQURIES_DELETE : "enquiry/delete",

HTML_RENDER_PRODUCT_DETAILS : "public/enquiry-details",



// IGM histort
IGM_HISTORY_LIST : "igm/list",
IGM_HISTORY_DELETE : "igm/delete",
IGM_HISTORY_SAVE : "igm/save",

//Gallery ENDPOINTS 
GALLERY_LIST : "gallery/list",
GALLERY_DELETE : "gallery/delete",
GALLERY_SAVE : "gallery/save",

// Testimonials ENDPONTS
TESTIMONIAL_SAVE : "testimonial/save",
TESTIMONIAL_LIST : "testimonial/list",
TESTIMONIAL_DELETE : "testimonial/delete",

//subscribed user data
SUBSCRIBER_NEWSLETTER : "subscribe-newletter/list",



}

export default API_ENDPOINTS;
